

































import Vue from "vue";
import { State, Getter, Action } from "vuex-class";
import { Component } from "vue-property-decorator";
import PlaceModel from "@/ts/models/placeClass";
import PlaceCard from "@c/molecules/place/PlaceCard.vue";
import PrimaryContentBody from "@/vue/layouts/PrimaryContentBody.vue";
import CreateButton from "@c/atoms/app/CreateButton.vue";

const namespace: string = "place";

@Component({
  name: "AllPlaces",

  components: {
    PlaceCard,
    PrimaryContentBody,
    CreateButton
  }
})
export default class Places extends Vue {
  @Getter("places", { namespace }) places?: Array<PlaceModel>;
  @Action("GET_ALL_PLACES", { namespace }) GET_ALL_PLACES: any;

  loading = false;

  created() {
    this.loading = true;
    this.GET_ALL_PLACES().then(() => {
      this.loading = false;
    });
  }
}
